// components/DeletedOrder.jsx
import React, { useEffect, useState } from 'react';
import styles from './DeletedOrder.module.css';
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';
import { FiTrash2, FiRotateCcw, FiAlertTriangle, FiMenu, FiX } from 'react-icons/fi';
import { FaBoxOpen } from 'react-icons/fa';
import { PulseLoader } from 'react-spinners';
import config from '../../config/config';

const DeletedOrder = () => {
  const [deletedOrders, setDeletedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const fetchDeletedOrders = async () => {
    try {
      const res = await fetch(`${config.apiBaseUrl}/api/deleted-orders`);
      if (!res.ok) throw new Error('Failed to fetch deleted orders');
      const data = await res.json();
      setDeletedOrders(data);
      setLoading(false);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch deleted orders:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedOrders();
  }, []);

  const handleRestore = async (id) => {
    try {
      const res = await fetch(`${config.apiBaseUrl}/api/user-orders/restore/${id}`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const result = await res.json();
      
      if (!res.ok) {
        throw new Error(result.message || 'Restore failed');
      }

      alert(`Order restored successfully!`);
      fetchDeletedOrders();
      
    } catch (err) {
      console.error("Restore error:", err);
      alert(`Restore failed: ${err.message}`);
    }
  };

  const handlePermanentDelete = async (id) => {
    if (!window.confirm("Are you sure you want to permanently delete this order? This action cannot be undone.")) return;

    try {
      const res = await fetch(`${config.apiBaseUrl}/api/deleted-orders/${id}`, {
        method: "DELETE",
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result.message || 'Delete failed');
      alert(result.message);
      fetchDeletedOrders();
    } catch (err) {
      console.error("Permanent delete failed:", err);
      alert(`Delete failed: ${err.message}`);
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <PulseLoader color="#4f46e5" size={15} />
        <p>Loading deleted orders...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <FiAlertTriangle className={styles.errorIcon} />
        <h3>Error Loading Orders</h3>
        <p>{error}</p>
        <button onClick={fetchDeletedOrders} className={styles.retryButton}>
          Retry
        </button>
      </div>
    );
  }

  return (
      <div className={styles.Docontainer}>
      <div className={styles.Doleft}>
      
        <button 
        className="products-mobile-nav-toggle"
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Imported Vertical Navigation */}
      <AdmVertNav 
        mobileNavOpen={mobileNavOpen} 
        closeMobileNav={() => setMobileNavOpen(false)} 
      />
      </div>

    <div className={styles.Doright}>
        
      <div className={styles.header}>
        <h2 className={styles.title}>
          <FiTrash2 className={styles.titleIcon} />
          Deleted Orders
        </h2>
        <p className={styles.subtitle}>Manage permanently deleted orders</p>
      </div>

      {deletedOrders.length === 0 ? (
        <div className={styles.emptyState}>
          <FaBoxOpen className={styles.emptyIcon} />
          <h3>No Deleted Orders Found</h3>
          <p>Orders you delete will appear here before permanent removal</p>
        </div>
      ) : (
        <div className={styles.orderGrid}>
          {deletedOrders.map(order => (
            <div key={order._id} className={styles.orderCard}>
              <div className={styles.cardHeader}>
                <span className={`${styles.statusBadge} ${order.status === 'accepted' ? styles.paid : styles[order.status]}`}>
                  {order.status === 'accepted' ? 'paid' : order.status}
                </span>
                <span className={styles.orderId}>Email: {order.shippingDetails?.email || "N/A"}
                    <br></br>
                    Phone: {order.shippingDetails?.phone || "N/A"}
                </span>
                
              
                
              </div>
              
              <div className={styles.cardBody}>
                <div className={styles.orderMeta}>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Amount:</span>
                    <span className={styles.metaValue}>Rs. {order.totalAmount.toLocaleString()}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Shipping:</span>
                    <span className={styles.metaValue}>Rs. {order.shippingCost.toLocaleString()}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Date:</span>
                    <span className={styles.metaValue}>{new Date(order.createdAt).toLocaleString()}</span>
                  </div>
                </div>

                <div className={styles.productsSection}>
                  <h4 className={styles.productsTitle}>Products</h4>
                  <ul className={styles.productsList}>
                    {order.products.map((prod, idx) => (
                      <li key={idx} className={styles.productItem}>
                        <span className={styles.productName}>{prod.name}</span>
                        <span className={styles.productQuantity}>× {prod.quantity}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className={styles.cardFooter}>
                <button 
                  onClick={() => handleRestore(order._id)} 
                  className={styles.restoreButton}
                >
                  <FiRotateCcw className={styles.buttonIcon} />
                  Restore
                </button>
                <button 
                  onClick={() => handlePermanentDelete(order._id)} 
                  className={styles.deleteButton}
                >
                  <FiTrash2 className={styles.buttonIcon} />
                  Delete Permanently
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
};

export default DeletedOrder;